import React, { useState } from 'react';
import { FiSearch, FiArrowRight, FiPlay, FiMessageCircle } from 'react-icons/fi';
import { toast } from '../Toast';
import { HELP_ICONS } from './helpIcons';
import { TOPICS, VIDEOS, POPULAR_SEARCHES, SUPPORT_EMAIL, PREVIEW_HELP } from './helpContent';

// /help — the full help centre ("Open full help centre" in the help panel). Content is the spec's; see helpContent.ts.
const HelpCentre: React.FC = () => {
    const [search, setSearch] = useState('');

    return <div className="v2-page help-v2">
        <div className="hero">
            {/* same skyscraper photo as the login brand panel and the dashboard glance panel (img, not CSS url: see decisions.md 2026-09-18) */}
            <img className="hero-bg" src="/images/login/brand-panel.jpg" alt="" />
            <h1>How can we help you today?</h1>
            <p>Search our guides, watch short videos, or talk to a real person in Australian business hours.</p>
            <form className="search" onSubmit={e => { e.preventDefault(); toast.info(PREVIEW_HELP); }}>
                <FiSearch />
                <input placeholder="Try “how do I email an announcement”" value={search} onChange={e => setSearch(e.target.value)} />
                <button type="submit" className="btn-primary">Search</button>
            </form>
            <div className="popular">
                <span>Popular:</span>
                {POPULAR_SEARCHES.map(s => <button key={s} type="button" onClick={() => toast.info(PREVIEW_HELP)}>{s}</button>)}
            </div>
        </div>

        <h2 className="section-heading">Browse by topic</h2>
        <div className="topics">
            {TOPICS.map(t => <div key={t.title} className="card topic">
                <div className="topic-head">
                    <span className="icon-tile">{HELP_ICONS[t.icon]}</span>
                    <div><strong>{t.title}</strong><span>{t.guides} guides</span></div>
                </div>
                <p>{t.description}</p>
                <button type="button" className="link" onClick={() => toast.info(PREVIEW_HELP)}>Open Guides <FiArrowRight /></button>
            </div>)}
        </div>

        <div className="help-row">
            <section className="card videos">
                <div className="section-title">
                    <span className="icon-tile"><FiPlay /></span>
                    <div><h2>Short Video Guides</h2><p>Each one is under 5 minutes, with captions</p></div>
                    <button type="button" className="link" onClick={() => toast.info('Preview only: videos aren’t available yet')}>All Videos <FiArrowRight /></button>
                </div>
                <div className="video-grid">
                    {VIDEOS.map(v => <button key={v.title} type="button" className="video" onClick={() => toast.info('Preview only: videos aren’t available yet')}>
                        <span className="thumb"><span className="play"><FiPlay /></span></span>
                        <strong>{v.title}</strong>
                        <small>{v.length} · Video</small>
                    </button>)}
                </div>
            </section>

            <section className="card contact">
                <div className="section-title">
                    <span className="icon-tile"><FiMessageCircle /></span>
                    <div><h2>Talk to a Person</h2><p>Mon–Fri, 8 am–6 pm AEST</p></div>
                </div>
                <button type="button" className="contact-row primary" onClick={() => toast.info('Preview only: live chat isn’t available yet')}>
                    <span className="text"><strong>Start a live chat</strong><small>Usually answered within 2 minutes</small></span><FiArrowRight />
                </button>
                <a className="contact-row" href={`mailto:${SUPPORT_EMAIL}`}>
                    <span className="text"><strong>Email {SUPPORT_EMAIL}</strong><small>We reply within one business day</small></span><FiArrowRight />
                </a>
                <button type="button" className="contact-row" onClick={() => toast.info('Preview only: call booking isn’t available yet')}>
                    <span className="text"><strong>Book a 30‑minute call</strong><small>Screen‑share with a specialist</small></span><FiArrowRight />
                </button>
                <div className="status"><span className="dot" /> All systems operating normally · status.investi.com.au</div>
            </section>
        </div>
    </div>;
};

export default HelpCentre;
